import { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { lockScroll, unlockScroll } from '../../scrollLock';

function IconClose() {
  return (
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M5.592 5.59a.82.82 0 0 1 1.16 0l5.249 5.261 5.249-5.26a.82.82 0 0 1 1.16 1.16l-5.26 5.248 5.26 5.249a.814.814 0 0 1 0 1.159l-.001.002a.815.815 0 0 1-1.159 0l-5.249-5.262-5.249 5.261a.815.815 0 0 1-1.159 0l-.002-.001a.815.815 0 0 1 0-1.159h.001l5.26-5.249-5.26-5.248a.82.82 0 0 1 0-1.16Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default function LegalDocumentModal({ open, title, html, onClose }) {
  const [phase, setPhase] = useState('enter');

  const handleClose = useCallback(() => {
    setPhase('leave');
    window.setTimeout(() => {
      onClose();
      setPhase('enter');
    }, 200);
  }, [onClose]);

  useEffect(() => {
    if (!open) return undefined;
    lockScroll();
    const openTimer = window.requestAnimationFrame(() => setPhase('open'));
    const onKey = (e) => { if (e.key === 'Escape') handleClose(); };
    window.addEventListener('keydown', onKey);
    return () => {
      window.cancelAnimationFrame(openTimer);
      unlockScroll();
      window.removeEventListener('keydown', onKey);
    };
  }, [open, handleClose]);

  if (!open || !title || !html) return null;

  return createPortal(
    <div
      className={`reg-terms-dialog${phase === 'open' ? ' is-open' : ''}${phase === 'leave' ? ' is-closing' : ''}`}
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div className="reg-terms-dialog__overlay" onClick={handleClose} />
      <div className="reg-terms-dialog__window">
        <div className="reg-terms-dialog__header">{title}</div>
        <button type="button" className="reg-terms-dialog__close" aria-label="Close" onClick={handleClose}>
          <IconClose />
        </button>
        <div className="reg-terms-dialog__scroll">
          <div className="reg-terms-dialog__markdown" dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      </div>
    </div>,
    document.body,
  );
}
